/* @ngInject */
function ExpirationController ($scope) {
  activate()

  function activate () {
    if (!$scope.date) {
      $scope.color = ''

      return
    }

    const newDate = moment($scope.date)
    const today = moment()
    const nextWeek = moment().add(7, 'days')
    const threeDays = moment().add(3, 'days')

    if (newDate < today) {
      $scope.color = ''
    } else if (newDate <= threeDays) {
      $scope.color = 'RED'
    } else if (newDate <= nextWeek) {
      $scope.color = 'YELLOW'
    } else {
      $scope.color = ''
    }
  }
}

export { ExpirationController }
